import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";
import {$viewSettingsFactory} from "../../$viewSettings.factory";

export class BringozQuickFiltersSelectCtrl implements IController {

  selectedId: any;
  pageName: string;
  isDisabled?: boolean;
  ngPlaceholder?: string;
  onChange: Function;


  private quickFiltersRef: any;
  public selectedQuickFilter: any;
  public selectedText: any;

  /* @ngInject */
  constructor(private $mdPanel, private $viewSettings: $viewSettingsFactory) {
    this.quickFiltersRef = this.$viewSettings();
  }

  $onInit() {
    this._setSelected();
  };

  $onChanges(changes) {
    if ((changes.selectedId && !changes.selectedId.isFirstChange())){
      this._setSelected();
    }
  };


  onShowPanel($event) {

    if (!!this.isDisabled) {
      return;
    }

    const panelPosition = this.$mdPanel.newPanelPosition()
      .relativeTo($event.target)
      .addPanelPosition(
        this.$mdPanel.xPosition.CENTER,
        this.$mdPanel.yPosition.BELOW // yPosition.BELOW
      );

    const panelAnimation = this.$mdPanel.newPanelAnimation()
      .openFrom($event)
      .duration(200)
      .closeTo('.bringoz-select-input')
      .withAnimation(this.$mdPanel.animation.FADE);

    const selectedIdRef = this.selectedId;
    const pageNameRef = this.pageName;
    const ngPlaceholderRef = this.ngPlaceholder;

    const config = {
      attachTo: angular.element(document.body),
      controllerAs: 'ctrl',
      position: panelPosition,
      animation: panelAnimation,
      targetEvent: $event,
      template: '<bringoz-select-filter-panel ' +
        'type="ctrl.typeRef" ' +
        'selected-id="ctrl.selectedIdsRef" ' +
        'query-map="ctrl.queryMapRef" ' +
        'ng-placeholder="ctrl.ngPlaceholderRef" ' +
        'panel-ref="ctrl.mdPanelRef" ' +
        '</bringoz-select-filter-panel>',
      controller: function () {
        this.typeRef = 'quickFilter';
        this.selectedIdsRef = selectedIdRef;
        this.queryMapRef = {
          pageName: pageNameRef
        };
        this.ngPlaceholderRef = ngPlaceholderRef;
      },
      clickOutsideToClose: true,
      escapeToClose: true,
      focusOnOpen: true,
      zIndex: 80,
      onCloseSuccess: (panel, selectedId) => {
        if (selectedId === 'clickOutsideToClose' || selectedId === 'escapeToClose') {
          selectedId = selectedIdRef;
        }

        if (!selectedId) {
          this.onChange({quickFilter: undefined, id: undefined});
          panel.destroy();
        } else {
          this.quickFiltersRef.$asyncValues([selectedId])
            .then((quickFilters) => {
              this.onChange({quickFilter: quickFilters[0], id: selectedId});
              panel.destroy();
            });
        }
      }
    };

    this.$mdPanel.open(config);
  }

  onResetFilter() {
    this.onChange({quickFilter: undefined});
  }

  private _setSelected() {
    if (!!this.selectedId) {
      this.quickFiltersRef.$asyncValues([this.selectedId])
        .then((quickFilters) => {
          this.selectedQuickFilter = _.orderBy(quickFilters, ['name'], ['asc'])[0];
          this._setSelectedText()
        });
    } else {
      this.selectedQuickFilter = undefined;
      this._setSelectedText()
    }
  }

  private _setSelectedText() {
    this.selectedText = _.get(this.selectedQuickFilter, 'name', '');
  }


}

angular
  .module('bringoz.admin.commons')
  .component('bringozQuickFiltersSelect', {
    bindings: {
      selectedId: '<',
      pageName: '<?',
      isDisabled: '<?',
      ngPlaceholder: '@?',
      onChange: '&',
    },
    template: require('./bringoz-quick-filters-select.html').default,
    controller: BringozQuickFiltersSelectCtrl
  });
